import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "price-history" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h6", { class: "font-normal" }, "History Perubahan Harga", -1)
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_6 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, { class: { 'card-no-shadow': true } }, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          value: _ctx.data,
          paginator: true,
          rows: _ctx.$numbers.totalItemPerPage,
          class: "table-og",
          responsiveLayout: "scroll"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, { header: "No" }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", _hoisted_3, _toDisplayString(slotProps.data.index), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Kode" }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", _hoisted_4, _toDisplayString(slotProps.data.Kode), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Perubahan Harga" }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.Basis)
                  ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(slotProps.data.Basis.Kode), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Tanggal Perubahan" }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", _hoisted_6, _toDisplayString(_ctx.moment(slotProps.data.TanggalBerlaku).format('DD MMMM YYYY')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "rows"])
      ]),
      _: 1
    })
  ]))
}